export default __webpack_public_path__ + "static/media/image2.b8edb4e0.f5cf1229.JPG";